"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledAmountDue = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
// todo: remove when ie11 becomes unsupported
var IE11StyledAmountDue = _styledComponents.default.div.withConfig({
  displayName: "AmountDuestyles__IE11StyledAmountDue",
  componentId: "sc-4h0cr9-0"
})(["display:-ms-grid;-ms-grid-columns:1fr;.c-amount-due-wrapper{-ms-grid-row:1;}.c-amount-due-subtext{-ms-grid-row:2;}.c-amount-due-follow-up{-ms-grid-row:3;}"]);

var StyledAmountDue = (0, _styledComponents.default)(IE11StyledAmountDue).withConfig({
  displayName: "AmountDuestyles__StyledAmountDue",
  componentId: "sc-4h0cr9-1"
})(["margin:", " auto;position:relative;width:max-content;.c-amount-due-wrapper{align-items:baseline;text-align:center;}.c-amount-due-amount{font-size:2.25rem;font-weight:", ";}.c-amount-due-subtext{font-weight:", ";padding:0.3rem 0 0;text-align:center;}.c-amount-due-follow-up{font-size:.8rem;padding:0;text-align:center;}@supports (display:grid){&{display:grid;grid-template-areas:\"amount\" \"componentSubtext\" \"amountFollowUp\";}.c-amount-due-wrapper{grid-area:amount;}.c-amount-due-subtext{grid-area:componentSubtext;}.c-amount-due-follow-up{grid-area:amountFollowUp;}}"], function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.theme.primaryHeavy;
}, function (props) {
  return props.theme.primaryHeavy;
});
exports.StyledAmountDue = StyledAmountDue;